module.exports = __webpack_public_path__ + "assets/img/icon-alarm-purple.be4022b7.png";